import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeveloperToolsRoutingModule } from './developer-tools-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DeveloperToolsRoutingModule
  ]
})
export class DeveloperToolsModule { }
